import tr from "./tr";
import en from "./en";

const languages = {
  tr: tr,
  en: en,
};

export default languages;
